import React from "react";
import { useTranslation } from "react-i18next";

const LegalPage = ({ tKey, testId }) => {
  const { t } = useTranslation();
  const sections = t(`${tKey}.sections`, { returnObjects: true });
  return (
    <div data-testid={testId}>
      <section
        style={{
          background: "linear-gradient(180deg, var(--pum-navy) 0%, var(--pum-navy-2) 100%)",
          color: "#fff",
          padding: "4rem 0 3.5rem",
        }}
      >
        <div className="pum-container">
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              fontSize: "0.72rem",
              textTransform: "uppercase",
              letterSpacing: "0.2em",
              color: "var(--pum-emerald)",
              fontWeight: 700,
            }}
          >
            <span style={{ width: 24, height: 1, background: "var(--pum-emerald)" }} /> Pumaria · Perú
          </span>
          <h1
            style={{
              color: "#fff",
              fontSize: "clamp(2rem, 4vw, 3rem)",
              marginTop: "1rem",
              marginBottom: "0.75rem",
              fontWeight: 900,
            }}
          >
            {t(`${tKey}.title`)}
          </h1>
          <p style={{ color: "#8FA5C7", fontSize: "0.9rem", letterSpacing: "0.05em" }}>
            {t(`${tKey}.updated`)}
          </p>
        </div>
      </section>

      <section style={{ padding: "3.5rem 0 5rem" }}>
        <div className="pum-container" style={{ maxWidth: 820 }}>
          <p
            style={{
              fontFamily: "var(--font-serif)",
              fontSize: "1.15rem",
              lineHeight: 1.65,
              color: "var(--pum-navy)",
              paddingBottom: "1.5rem",
              borderBottom: "1px solid var(--pum-gray-200)",
              marginBottom: "2.5rem",
            }}
            data-testid={`${testId}-intro`}
          >
            {t(`${tKey}.intro`)}
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: "1.75rem" }}>
            {sections.map((s, i) => (
              <div key={i} data-testid={`${testId}-section-${i}`}>
                <h2
                  style={{
                    fontSize: "1.2rem",
                    marginBottom: "0.65rem",
                    color: "var(--pum-navy)",
                  }}
                >
                  {s.title}
                </h2>
                <p style={{ color: "var(--pum-gray-700)", fontSize: "0.98rem", lineHeight: 1.7 }}>
                  {s.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
